import React from 'react';
import { SelectInput } from 'react-admin';
import { useGetAllProducts } from '~/hooks/product';
import { useExternalSourceTypes } from '~/hooks/externalSources';
import { useTranslate } from 'react-admin';
import { Skeleton } from '@material-ui/lab';
import { FORM_CONTROL_WIDTH } from '~/hooks/useListFilterStyles';

interface AllPaymentInstrumentsSelectProps {
  source: string;
  label?: string;
  className?: string;
  emptyText?: string;
  alwaysOn?: boolean;
}

const AllPaymentInstrumentsSelect: React.FC<AllPaymentInstrumentsSelectProps> = ({
  source,
  label,
  className,
  emptyText,
  alwaysOn = true,
}) => {
  const translate = useTranslate();
  const td = (key: string): string => translate(`utils.${key}`);

  const {
    data: externalSourceTypesData,
    isFetching: externalSourceTypesLoading,
  } = useExternalSourceTypes();
  const { data: productsData, isFetching: productsLoading } = useGetAllProducts();

  if (externalSourceTypesLoading || productsLoading) {
    return (
      <Skeleton variant='rect' width={FORM_CONTROL_WIDTH} height={45} style={{ borderRadius: 4 }} />
    );
  }

  const externalSourceTypes =
    externalSourceTypesData?.map((type) => ({
      id: type,
      name: type,
    })) ?? [];
  const products =
    productsData?.map((product) => ({
      id: product?.id,
      name: product?.name,
    })) ?? [];

  const emptyChoice = emptyText ? [{ id: '', name: td('any') }] : [];
  const choices = emptyChoice.concat([...(externalSourceTypes || []), ...(products || [])]);

  if (externalSourceTypesLoading || productsLoading) return <Skeleton />;

  return (
    <SelectInput
      choices={choices}
      source={source}
      label={label}
      className={className}
      helperText={false}
      defaultValue=''
      emptyText={emptyText}
      alwaysOn={alwaysOn}
      translateChoice={false}
      allowEmpty={false}
    />
  );
};

export default AllPaymentInstrumentsSelect;
